<!-- TEMPLATE -->
<template>
    <div :class='quotesListClass'>
        <div class='row'>
            <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
                <dean-section-title content='true'>
                  <span slot='title'>
                    <span class='avenir-heavy'>Offertes</span>
                  </span>
                  <dean-section-title-item
                    v-if="canCreateQuote()"
                    :icon='plusIcon'
                    :content="true"
                    @click.native="sectionRoute('quotes.add.customers.list.partner', {
                    partnerId: $route.params.pid,
                  })"
                  >
                      Nieuw
                  </dean-section-title-item>
                </dean-section-title>

                <dean-table
                  :data='quotesData'
                  :columns='columns'
                  :hover="true"
                  @column-click='columnClick'
                  @cell-click="cellClick"
                >
                </dean-table>

                <dean-pagination
                  :current-page='quotesMetaData.pageNumber'
                  :total-items='quotesMetaData.totalResults'
                  :items-per-page='quotesMetaData.itemsPerPage'
                  :select-items-per-page='selectItemsPerPage'
                  :visible-pages='quotesMetaData.visiblePages'
                  @page-changed='paginationChanged'
                  @items-per-page='itemsPerPageChanged'
                >
                </dean-pagination>
            </div>
        </div>
    </div>
</template>

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import sideMenuPartnerMixin from '@/mixins/sideMenuPartnerMixin';
  import {mixins} from 'vue-class-component';
  import {getDutchDateFormat} from '@/mixins/dateWrapper';

  import {
    // SVG
    invoicesIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    plusIcon,
    summeryIcon,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      summeryIcon,
    },
  })
  export default class List extends mixins(deanTableMixin, sideMenuPartnerMixin) {

    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public data: object[] = [];

    // COMPUTED
    get quotesListClass() {
      let value = 'quote-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get quotesMetaData() {
      return this.pageMeta;
    }

    get quotesData() {
      return this.data;
    }

    public columns: any = {
      number: {
        content: 'code',
        align: 'left',
        sort: true,
        dql: 'number',
      },
      customerName: {
        content: 'klantnaam',
        align: 'left',
        sort: true,
        dql: 'customerName',
      },
      partnerName: {
        content: 'partnernaam',
        align: 'left',
        sort: true,
        dql: 'partnerName',
      },
      pchsnr: {
        content: 'pc/hsnr',
        align: 'left',
        sort: true,
        dql: 'pchsnr',
      },
      city: {
        content: 'plaats',
        align: 'left',
        sort: true,
        dql: 'city',
      },
      quoteDate: {
        content: 'date',
        align: 'left',
        sort: true,
        dql: 'quoteDate',
      },
      recurringPrice: {
        content: 'maandelijks',
        type: 'currency',
        align: 'left',
        sort: true,
        dql: 'recurringPrice',
      },
      status: {
        content: 'status',
        align: 'left',
        sort: true,
        dql: 'status',
      },
    };

    public tableName(): string {
      return 'partner-quotes';
    }

    public cellClick(target: { cell: object, row: any, column: string }) {
      this.$router.push({
        name: 'quotes.edit',
        params: {id: target.row.id},
      });
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      const url = '/-/trade/api/partner.quotes.list';

      const requestData = {
        meta: {
          startIndex: this.startIndex,
          numberOfItems: data.itemsPerPage,
        },
        sort: data.sort,
        pid: this.$route.params.pid,
      };

      axios.post(url, requestData)
        .then(
          (response) => {
            this.data = [];
            for (const item of response.data.data) {
              const row = {
                id: item.id,
                personId: this.$route.params.pid,
                number: item.number,
                customerName: item.customer.name,
                partnerName: item.partner.name,
                pchsnr: item.address ? (item.address.postalCode +
                    ' / ' +
                    item.address.houseNumber + (
                        item.address.houseNumberExtension ?
                            '-' + item.address.houseNumberExtension :
                            ''
                    )
                ) : '-',
                city: item.address ? item.address.city : '-',
                quoteDate: getDutchDateFormat(item.created),
                recurringPrice: item.recurringPrice,
                status: item.status,
              };
              this.data.push(row);
            }

            this.updateMeta(response.data.meta);
          }).then(
        // Resolve promise response/error
        (response) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
        (error) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }

    public canCreateQuote(): boolean {
      if (this.$store.getters.getUser.privileges.includes('create-quote')) {
        return true;
      }

      return false;
    }

    public created() {
      this.setDefaultSort('number');
      this.loadList(this.pageMeta);
      this.buildSideMenuPartner();
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
    @import '~@deanone/dean-components/src/scss/vars';
</style>